'use client'

import { Volume2, VolumeX } from 'lucide-react'
import { useEffect, useRef, useState } from 'react'

interface YouTubePlayer {
  destroy: () => void
  mute: () => void
  unMute: () => void
  playVideo: () => void
}

declare global {
  interface Window {
    YT: {
      Player: new (
        elementId: string,
        config: {
          height: string
          width: string
          videoId: string
          playerVars?: {
            autoplay?: number
            mute?: number
            controls?: number
            modestbranding?: number
            rel?: number
            playsinline?: number
            loop?: number
            playlist?: string
          }
          events?: {
            onReady?: () => void
          }
        }
      ) => YouTubePlayer
    }
    onYouTubeIframeAPIReady: () => void
  }
}

export default function HeroSection() {
  const [isMuted, setIsMuted] = useState(true)
  const playerRef = useRef<YouTubePlayer>(null)

  useEffect(() => {
    // Load YouTube IFrame API
    const tag = document.createElement('script')
    tag.src = 'https://www.youtube.com/iframe_api'
    document.body.appendChild(tag)

    window.onYouTubeIframeAPIReady = () => {
      playerRef.current = new window.YT.Player('youtube-player', {
        height: '100%',
        width: '100%',
        videoId: 'cg6w2MhWIwA',
        playerVars: {
          autoplay: 1,
          mute: 1,
          controls: 0,
          modestbranding: 1,
          rel: 0,
          playsinline: 1,
          loop: 1,
          playlist: 'cg6w2MhWIwA',
        },
        events: {
          onReady: () => {
            // Video is ready to play
            playerRef.current?.playVideo()
          },
        },
      })
    }

    return () => {
      if (playerRef.current?.destroy) {
        playerRef.current.destroy()
      }
    }
  }, [])

  const toggleSound = () => {
    if (playerRef.current) {
      if (isMuted) {
        playerRef.current.unMute()
      } else {
        playerRef.current.mute()
      }
      setIsMuted(!isMuted)
    }
  }

  return (
    <section className='relative min-h-[56vh] w-full overflow-hidden md:min-h-[70vh] 2xl:min-h-screen'>
      <div className='absolute inset-0'>
        <div id='youtube-player' className='pointer-events-none h-full w-full' />
      </div>
      <button
        onClick={toggleSound}
        className='absolute left-4 top-4 z-10 flex h-10 w-10 items-center justify-center rounded-full bg-black/50 text-white transition-colors hover:bg-black/70'
        aria-label={isMuted ? 'Unmute video' : 'Mute video'}
      >
        {isMuted ? <VolumeX size={20} /> : <Volume2 size={20} />}
      </button>
    </section>
  )
}
